import {
  parse,
  type StringifiableRecord,
  stringify,
  type StringifyOptions,
} from '@contra/utilities/queryString';

export const appendSearch = (
  path: string,
  search?: StringifiableRecord,
  options?: StringifyOptions,
): string => {
  const [nextPath, firstQuery] = path.split('?');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const nextQuery = stringify(search as Record<string, any>, options);

  if (!nextQuery) {
    return path;
  }

  if (firstQuery) {
    return (
      nextPath + '?' + stringify(parse(firstQuery + '&' + nextQuery), options)
    );
  }

  return nextPath + '?' + nextQuery;
};
